import { useTranslation } from 'react-i18next';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import TestimonialSection from './components/TestimonialSection';
import TravelSection from './components/TravelSection';
import SchoolSection from './components/SchoolSection';
import CTASection from './components/CTASection';
import ProfileSection from './components/ProfileSection';
import ContactSection from './components/ContactSection';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <ServicesSection />
      <FeaturesSection />
      <TravelSection />
      <SchoolSection />
      <AboutSection />
      <TestimonialSection />
      <CTASection />
      <ProfileSection />
      <ContactSection />
      <Footer />
    </div>
  );
}
